import React from 'react';

/**
 * Memoized error boundary component for displaying component errors
 * @param {Object} props - Component props
 * @param {Error} props.error - Error object (optional)
 * @param {string} props.componentName - Name of the component that failed
 * @returns {JSX.Element} Error boundary component
 */
const ErrorBoundary = React.memo(({ error, componentName }) => (
  <div style={{ 
    padding: "16px", 
    textAlign: "center", 
    fontSize: "14px",
    color: error ? "#dc3545" : "#6c757d",
    border: error ? "2px solid #dc3545" : "2px dashed #e9ecef",
    borderRadius: "8px",
    backgroundColor: error ? "#f8d7da" : "#f8f9fa",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }}>
    <div style={{ fontWeight: "600", marginBottom: "4px" }}>
      {error ? "Render Error" : "Component Not Found"}
    </div>
    <div style={{ fontSize: "12px" }}>
      {error ? error.message : componentName}
    </div>
  </div>
));

ErrorBoundary.displayName = 'ErrorBoundary';

export default ErrorBoundary;
